module.exports = __webpack_public_path__ + "static/atelier-a634739610ebf844c9e95c8143bd5dfa.png";